export const logger = require('debug')('iam');
